import React, { createContext, useContext, useMemo, useState } from "react";

type SearchContextType = {
  searchTerm: string;
  selectedItem: string;
  setSearchTerm: (term: string) => void;
  setSelectedTerm: (term: string) => void;
};

const SearchContext = createContext<SearchContextType | undefined>(undefined);

export const SearchProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [searchTerm, setSearchTerm] = useState("");
  const [selectedItem, setSelectedTerm] = useState("");

  const searchContextValue = useMemo(
    () => ({
      searchTerm,
      selectedItem,
      setSearchTerm,
      setSelectedTerm,
    }),
    [searchTerm, selectedItem, setSearchTerm, setSelectedTerm]
  );

  return (
    <SearchContext.Provider value={searchContextValue}>
      {children}
    </SearchContext.Provider>
  );
};

export const useSearchContext = () => {
  const ctx = useContext(SearchContext);
  if (!ctx) throw new Error("useSearchContext must be used within a SearchProvider");
  return ctx;
};
